import React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {isAllowedFrame} from './utils/frameGuard';

class SilentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress the error without logging it
    // You can also choose to log it to an external service if needed
  }

  render() {
    if (this.state.hasError) {
      // Render a fallback UI or nothing
      return null; // or <div>Something went wrong.</div>
    }

    return this.props.children; 
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isAllowedFrame(process.env.NODE_ENV !== 'production')) {
  root.render(
    <React.StrictMode>
      <SilentErrorBoundary>
        <App />
      </SilentErrorBoundary>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '24px',
          textAlign: 'center',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#374151',
        }}
      >
        <p style={{maxWidth: '320px', fontSize: '14px', lineHeight: 1.5}}>
          This page can only be accessed from within Bitespeed.
        </p>
      </div>
    </React.StrictMode>
  );
}

